import { Link, Typography } from '@mui/material';
import { UiThemeOverrider, useUiTheme } from 'framework/uiTheme';
import { useListContext } from 'framework/list';
import { SanitizedHtml } from 'framework/utils';
import PhoneField from '../text/PhoneField';
import { FieldProps } from '../types';
import { highlightSearchString } from './SearchResultField';

const PhoneFieldLayout = ({ phone, phoneExtension, label }: FieldProps) => {
  const { BaseFieldLayout } = useUiTheme();
  const { search } = useListContext();
  const displayPhone = phone ? (search ? phone.replace(/[ +)(-]/g, '') : phone) : '';

  const displayValue = phone ? (
    <>
      <Link href={`tel:${phone}`} color="primary" underline="none" variant="body1">
        {search ? <SanitizedHtml html={highlightSearchString(displayPhone, search)} /> : displayPhone}
      </Link>

      {phoneExtension && (
        <Typography component="span" variant="body1" className="extension" sx={{ ml: 0.5 }}>
          ext {phoneExtension}
        </Typography>
      )}
    </>
  ) : null;

  return <BaseFieldLayout value={displayValue} label={label} />;
};

const PhoneSearchField = (props: FieldProps) => {
  return (
    <UiThemeOverrider
      overriddenLayouts={{
        PhoneFieldLayout,
      }}
    >
      <PhoneField {...props} />
    </UiThemeOverrider>
  );
};

export default PhoneSearchField;
